import {
  createDocument,
  getAllData,
  updateDocumentByID,
} from "apis/customApiHandler";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Input, Select } from "styled";
import { TD, TH } from "styled/table";
import { BiCloudDownload } from "react-icons/bi";
import axios from "apis/axios";
import ReactSelect from "react-select";
import Spinner from "components/Spinner";
import exportExcel from "utils/exportExcel";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import getFormattedDate from "utils/helpers";
import Modal from "components/Modal";
import { useFormik, Form, FormikProvider } from "formik";
import InputField from "components/formik/InputField";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";

import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import CreateDeEnrollment from "components/vehicle-deenrollment/CreateDeEnrollment";

const VehicleDeEnrollmentReport = () => {
  const ids = window.location.search.split("=")[1];
  const currentUser = useSelector((state) => state.user.currentUser);

  const [selectedFleets, setSelectedFleets] = useState([]);
  const [showEditModel, setShowEditModel] = useState(false)
  const [selectedConfigurations, setSelectedConfigurations] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [page, setPage] = useState(1);
  const [kmFrom, setKmFrom] = useState("");
  const [kmTo, setKmTo] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [contractType, setContractType] = useState("All");
  const [alignment, setAlignment] = useState("All");
  const [rotation, setRotation] = useState("All");
  const [replacement, setReplacement] = useState("All");
  const [reportData, setReportData] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async (pg) => {
    setIsLoading(true);
    const dt = await createDocument("/de-enrollment/report", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
        ...(selectedConfigurations?.includes("all")
        ? {
          configurations: getConfigurationOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedConfigurations.length && {
          configurations: selectedConfigurations.map((configuration) => configuration).join(","),
          }),
      searchQuery,
      dateFrom,
      dateTo,
      page: pg ? pg : page,
      download: 0,
      limit: 20,
    });
    // console.log(dt)
    setData(dt);
    setIsLoading(false);
  };

  useEffect(() => {
    if (
      (selectedFleets.length === 0 || selectedHubs.length === 0) &&
      !searchQuery
    ) {
      // console.log("");
    } else getData(page);
  }, [page]);

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const { data: allConfigurations } = useQuery([`/vehicle-configuration-master`], () =>
    getAllData("/vehicle-configuration-master", {
    })
  );

  const getDownloadData = async () => {
    setDownloading(true);
    const dt = await createDocument("/de-enrollment/report/download", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
      ...(ids && {
        ids,
      }),
      searchQuery,
      dateFrom,
      dateTo,
    });
    // console.log(dt)
    if (dt?.data) setReportData(dt.data);
    exportExcel(
      dt?.data?.map((x, idx) => ({
        "S.N": idx + 1,
        "De Enrollment Date": getFormattedDate(x.vehicleDeEnrollmentDate,'-'),
        "Fleet Name": `${x?.fleet} ${x?.fleetCity ? `(${x.fleetCity})` : ""}`,
        "Hub Name": x?.hub,
        "Vehicle No.": x?.vehicle,
        "Configuration": x.configuration,
        "Tyres": x.deEnrolledTyres,
        "KillometerTravelled": x.killometerTravelled,
        "Odometer Reading": x.odometerReading,
        "Odometer Status": x.odometerStatus ? "Working" : "Not Working",
        "De-Enrollment By": x.deEnrolledBy
      })),
      "de-enrollment.xlsx"
    );
    setDownloading(false);
  };

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  const getConfigurationOptions = useCallback(() => {
    if (allConfigurations && allConfigurations.data && allConfigurations.data.length) {
      const configs = [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allConfigurations.data.map((configuration) => ({
          value: configuration._id,
          label: `${configuration.make?.makeName}/${configuration.model?.name}/${configuration.name}`,
        })),
      ];
      return configs;
    }
    return [];
  }, [allConfigurations]);

  console.log('selectedFleets--', selectedFleets)

  return (
    <div>
      <div className="flex flex-col text-gray-500">
        <div className="w-full px-8 flex justify-center items-center gap-4">
          <label className="w-full py-3">
            Select Fleets
            <ReactSelect  
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find((item) => item?.value === fleet)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                let allValues = value?.map((item) => item.value);
                if(allValues?.includes("clear")){
                  // console.log(allValues)
                  setSelectedFleets([]);
                  setSelectedHubs([]);
                  return;
                }
                if(!selectedFleets?.includes("all") && allValues.includes("all")){
                  setSelectedFleets(["all"]);
                  return;
                }

                if (selectedFleets.includes("all")) {
                  // console.log("first");
                  // console.log(getFleetOptions())
                  value = value.filter(item => item.value!== "all")
                }

                let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  value?.map((item) => item.value)?.includes(fleet._id)
                );

                let selectedHubsVal = allHubs?.data?.filter((hub) =>
                  selectedHubs?.map((item) => item)?.includes(hub._id)
                );
                
                setSelectedHubs(
                  selectedHubsVal
                    ?.filter((hub) =>
                      selectedFleetsVal?.find(
                        (fleet) => fleet.fleetCode === hub.fleetCode
                      )
                    )
                    .map((hub) => hub._id)
                );

                // console.log({allHubs, selectedHubs})
                
                setSelectedFleets(value.map((fleet) => fleet.value));
                }
            }
              name="fleets"
              isMulti = {true}
            />
          </label>
          <label className="w-full py-3">
            Select Hubs
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  // console.log({hub})
                  return {
                    value: hub,
                    label: getHubOptions()?.find((item) => item.value === hub)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                // console.log({allValues})
                if(allValues.includes("clear")){
                  setSelectedHubs([])
                  return;
                }
                if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                  let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                    selectedFleets?.includes(fleet._id)
                  )?.map(fleet=>fleet.fleetCode);

                  const selectedHubsData = allHubs?.data?.filter(hub=> selectedFleetCodes?.includes(hub.fleetCode))

                  const mp = fleetMap;
                  selectedHubsData.map(hub=>{
                    if(selectedFleetCodes?.includes(hub.fleetCode)){
                    if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                  }})

                  setFleetMap(mp);
                  setSelectedHubs(["all"])
                } 
                else {
                  // console.log({value})
                  value = value.filter(value => value.value!== "all")
                  // console.log({value})
                  let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                    selectedFleets?.includes(fleet._id)
                  )?.map(fleet=>fleet.fleetCode);
                  // console.log({allValues})
                
                  const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
                  const mp = {};
                  selectedHubsData.map(hub=>{
                    mp[hub.fleetCode] = [];
                  })

                  selectedHubsData.map(hub=>{
                    if(selectedFleetCodes?.includes(hub.fleetCode)){
                    if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                  }})

                  setFleetMap(mp);                  
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>

          <label className="w-full py-3">
            Select Configuration
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getConfigurationOptions()}
              value={selectedConfigurations.map((configuration) => {
                if (configuration === "all") {
                  return { value: "all", label: "All" };
                }
                const config = allConfigurations.data.find((item) => item._id === configuration);
                return {
                  value: configuration,
                  label: `${config?.make?.makeName}/${config?.model?.name}/${config?.name}`,
                };
              })}
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                if (allValues.includes("clear")) {
                  setSelectedConfigurations([]);
                  return;
                }
                if (!selectedConfigurations.includes("all") && allValues.includes("all")) {
                  setSelectedConfigurations(["all"]);
                  return;
                }
                if (selectedConfigurations.includes("all")) {
                  value = value.filter((item) => item.value !== "all");
                }
                setSelectedConfigurations(value.map((configuration) => configuration.value));
              }}
              name="configurations"
              isMulti={true}
            />
          </label>
          
        </div>
        <div className="w-full px-8 flex justify-start items-center gap-4">
          <label>
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label>
            End Date{" "}
            <Input
              type="date"
              min={getFormattedDate(dateFrom)}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>
          <label>
            Vehicle Number
            <Input
              type="text"
              name="searchQuery"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </label>
          <Button
            type="button"
            bgPrimary
            className='mt-5'
            onClick={() => {
              setPage(1);
              getData();
            }}
            disabled={
              (selectedFleets.length === 0 || selectedHubs.length === 0) &&
              !selectedConfigurations?.length && 
              !searchQuery
            }
          >
            Search
          </Button>
          {downloading
            ? "Downloading..."
            : selectedHubs.length !== 0 && (
                <BiCloudDownload
                  className="w-10 mt-5 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
                  onClick={async () => {
                    await getDownloadData();
                  }}
                />
              )}
        </div>
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {data && (
            <div className="flex flex-col m-2 lg:m-10">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <TH scope="col">S.N.</TH>
                          <TH scope="col">De-Enrollment Date</TH>
                          <TH scope="col">Fleet Name</TH>
                          <TH scope="col">Hub Name</TH>
                          <TH scope="col">Vehicle Number</TH>
                          <TH scope="col">Configuration</TH>
                          <TH scope="col">Tyres</TH>
                          <TH scope="col">De Enrolled By</TH>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {data &&
                          data.data?.map((d, idx) => (
                            <ViewList
                              key={`${d?.vehicle ?? idx}-${d?.vehicleDeEnrollmentDate ?? idx}`}
                              page={page}
                              data={d}
                              idx={idx}
                              getData={getData}
                            />
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {showEditModel && (
        <CreateDeEnrollment
          data={data}
          handleClick={() => setShowEditModel(false)}
          getData={getData}
        />
      )}

              {data && data.pageInfo && data.pageInfo.total && (
                <div className="container mx-auto flex justify-center items-center gap-2 py-5">
                  <Button
                    onClick={() => {
                      setPage((p) => Math.max(p - 1, 1));
                    }}
                    disabled={page === 1}
                    className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                    primary
                  >
                    <div className="flex gap-1 items-center">
                      <IoMdArrowBack />
                      Prev Page
                    </div>
                  </Button>
                  <span className="text-gray-600 px-4">{`showing: ${
                    (page - 1) * 20 + 1
                  } - ${Math.min(data?.pageInfo?.total, page * 20)} of ${
                    data.pageInfo.total
                  }`}</span>

                  {data.pageInfo.total > page * 20 && (
                    <Button
                      onClick={() => {
                        setPage((p) => Math.min(p + 1, data?.pageInfo?.total));
                      }}
                      disabled={page === data?.pageInfo?.total}
                      className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                      primary
                    >
                      <div className="flex gap-1 items-center">
                        Next Page
                        <IoMdArrowForward />
                      </div>
                    </Button>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default VehicleDeEnrollmentReport;

const ViewList = ({ data, page, idx, getData, prevInspection }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [showEditModel, setShowEditModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);

  const modalHandler = useCallback(
    (data) => {
      if (data) {
        setModalData(data);
        setShowModal(true);
      } else {
        setShowModal(false);
        setModalData([]);
      }
    },
    [showModal, modalData]
  );

  const fetchFile = async (url) => {
    const originalImage = url;
    const image = await fetch(originalImage);

    //Split image name
    const nameSplit = originalImage.split("/");
    const duplicateName = nameSplit.pop();

    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = "" + duplicateName + "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // console.log('modal',modalData)
  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={modalData.title}
          className="max-w-2xl"
        >
          {/* <h1>This is the modal</h1> */}
          <h1 className="w-full flex justify-end text-end px-2 my-1">
            <Button
              onClick={() => {
                const tyreIds = (modalData?.data ?? [])
                  .map((deEnrolledTyre) => deEnrolledTyre?.tyre?.[0]?._id)
                  .filter(Boolean);

                if (!tyreIds.length) {
                  toast.error("No tyres available to download");
                  return;
                }

                const myPromise = axios({
                  method: 'post',
                  data: {
                    tyres: tyreIds.join(","),
                    reportName: "De-enrolled Tyres",

                  },
                  url: `report/fleetStockDetails/download`,
                });

                toast.promise(myPromise, {
                  loading: 'Request Initiated, Please Hold on',
                  success: (dt) => {
        
                    // console.log(dt)
                    return dt.data.message;
                  },
                  error: (err) =>{
                    // console.log({err});
                    return err?.response?.data.error ||
                    err?.response?.data.message ||
                    err?.message ||
                    'Something went wrong'},
                },
                {
                  success: {
                    duration: 3000,
                    icon: '📩',
                  },
                });
              }}
              className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
            >
              Download
            </Button>
          </h1>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <TH scope="col">S.N.</TH>
                <TH scope="col">StencilNo</TH>
                <TH scope="col">De Enrolled Position</TH>
                <TH scope="col">Current Location</TH>
              </tr>
            </thead>
            <tbody>
              {/* {modalData.map((item, index) => ( */}
              {modalData &&
                modalData?.data?.length > 0 &&
                modalData.data.map((item, index) => (
                <tr key={item?._id ?? index}>
                  <TD>{index + 1}</TD>
                  <TD>{item?.tyre?.length? item?.tyre[0].stencilNo : "---"}</TD>
                  <TD>{item.deEnrolledPosition}</TD>
                  <TD>{item.finalTyreStatus}</TD>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{(parseInt(page) - 1) * 20 + (idx + 1)}</TD>
        <TD>{getFormattedDate(data?.vehicleDeEnrollmentDate, "/")}</TD>
        <TD>{`${data?.fleet} ${data?.fleetCity ? `(${data.fleetCity})` : ""}`}</TD>
        <TD>{data?.hub}</TD>
        <TD>{data?.vehicle ?? "NA"}</TD>
        <TD>{data?.configuration ?? "NA"}</TD>
        {/* <TD>{data?.deEnrolledTyres?.length ?? 0}</TD> */}
        <TD
          
        >
          <div className="flex gap-2 items-center justify-end">
    <span
className={
  data?.deEnrolledTyres ? "hover:text-green-500 cursor-pointer flex" : "flex"
}
onClick={
  data?.deEnrolledTyres ? () => modalHandler({data: data?.deEnrolledTyres,
    title: "Vehicle Information " + data.fleet + (data.fleetCity ? ` (${data.fleetCity})` : "")
    }) : null
  // data?.deEnrolledTyres ? () => modalHandler(data.deEnrolledTyres) : null
}    >
                {data?.deEnrolledTyres?.length ?? 0}

    </span>
    {/* <BiCloudDownload
      className="w-8 h-8 text-green-500 hover:scale-105 cursor-pointer text-center"
      onClick={async () => {

        // console.log({fleetMap, fleetCode})


        const myPromise = axios({
          method: 'post',
          data: {
            tyres: data.deEnrolledTyres.map(deEnrolledTyre=>deEnrolledTyre.tyre[0]._id).join(","),
            reportName: "De-enrolled Tyres",

          },
          url: `report/fleetStockDetails/download`,
        });

        toast.promise(myPromise, {
          loading: 'Request Initiated, Please Hold on',
          success: (dt) => {

            // console.log(dt)
            return dt.data.message;
          },
          error: (err) =>{
            // console.log({err});
            return err?.response?.data.error ||
            err?.response?.data.message ||
            err?.message ||
            'Something went wrong'},
        },
        {
          success: {
            duration: 3000,
            icon: '📩',
          },
        });


        // console.log(dt)
        
      }}
    /> */}
  </div>
          
        </TD>

        <TD>{data?.deEnrolledBy ?? "NA"}</TD>
      </tr>
    </Fragment>
  );
};